import React, { Component } from "react";
import { Loader, Nav, Card, Modal, FormCheckbox } from "ui-kit-ck-consultant";
import { Row, Col } from "react-flexbox-grid";
import FadeIn from "react-fade-in";
import GoogleMapReact from "google-map-react";
import {
  faUserAlt,
  faBuilding,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

import ShowOptionsNGRA from "../../components/general/ShowOptionsNGRA-v2";
import MapMarker from "../../components/planning/tour/MapMarker";
import TourMarker from "../../components/tracking/TourMarker";
import TourLegend from "../../components/tracking/TourLegend";

import axiosConfig from "../../utils/axiosConfig";
import expertColor from "../../utils/expertColor";
import GOOGLE_MAPS_KEY from "../../utils/googleMaps";
import filterStore from "../../stores/filterStore";

export default class Tracking extends Component {
  constructor(props) {
    super(props);
    const saved = filterStore.getState().getPageState("tracking");
    // googleMaps est remis à null : l'objet sauvegardé référence la carte de
    // l'instance précédente, démontée. Les tracés seront refaits par
    // handleApiLoaded quand la nouvelle carte sera prête.
    //
    // isLoad est forcé à false : le chargement initial est lancé par
    // componentDidMount, et un état sauvegardé pendant un chargement
    // rouvrirait sinon la page bloquée sous le Loader.
    // selectedExpert est ramené à null s'il manque : `undefined` passerait le
    // test `!== null` et ferait disparaître les marqueurs de "toutes les
    // expertises", filtrés sur un expert inexistant.
    this.state = saved
      ? {
          ...saved,
          googleMaps: null,
          isLoad: false,
          selectedExpert: saved.selectedExpert ?? null,
        }
      : {
          // Surtout pas `true` : ShowOptionsNGRA reçoit isChange={true}, donc
          // il n'appelle onDataChange QUE sur clic du bouton "Rechercher"
          // (handleDataChange a pour valeur par défaut !isChange, soit false,
          // ce qui court-circuite les appels internes au montage). Avec isLoad
          // à true au départ, le Loader — un calque plein écran en z-index 10 —
          // restait donc affiché indéfiniment et interceptait le clic sur
          // "Rechercher", rendant la page définitivement inutilisable. Les
          // autres pages bâties sur ce composant (Anomaly, Precisia,
          // CompetitiveCost) partent elles aussi de false.
          isLoad: false,
          isEmpty: false,
          isModal: false,
          idxModal: null,
          // ShowOption state
          network: 0,
          group: 0,
          region: 0,
          agency: 0,
          user: 0,
          // Même défaut que le champ "Date" de ShowOptionsNGRA (dateEnd), pour
          // que le chargement initial porte sur la même journée que celle
          // affichée dans la barre de filtres.
          date: moment().format("YYYY-MM-DD"),
          // data
          data: [],
          dataRoads: {},
          dataAgency: [],
          total: null,
          // Tournée isolée sur la carte (id de l'expert), null = toutes.
          selectedExpert: null,
          googleMaps: null,
          isAllFolder: false,
          isAgency: true,
          dateSync: false,
        };

    this.timeoutData = null;

    this.flightPaths = [];
  }

  componentDidMount() {
    // ShowOptionsNGRA est en isChange={true} : il n'appelle onDataChange que
    // sur clic de "Rechercher". La première recherche est donc lancée ici, avec
    // les valeurs par défaut de la barre de filtres. Les rafraîchissements
    // suivants restent manuels, via ce même bouton.
    // On ne relance rien si l'on revient sur la page avec un état déjà chargé.
    if (!this.state.data.length && !this.state.isEmpty) {
      this.getData();
    }
  }

  componentWillUnmount() {
    if (this.timeoutData !== null) {
      clearInterval(this.timeoutData);
      this.timeoutData = null;
    }

    filterStore.getState().setPageState("tracking", this.state);
  }

  // ShowOption data

  handleDataChange = (data) => {
    filterStore.getState().setPageFilters("tracking", data);
    this.setState(
      {
        network: data.network,
        group: data.group,
        region: data.region,
        agency: data.agency,
        user: data.user,
        date: data.dateEnd,
      },
      () => {
        this.getData();
      }
    );
  };

  handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    this.setState({ [name]: checked });
  };

  hasValueDeep = (json, findValue) => {
    for (var key in json) {
      if (json[key]["lat"] === findValue) return true;
    }
    return false;
  };

  decodePolyline(encoded) {
    if (!encoded) {
      return [];
    }
    var poly = [];
    var index = 0,
      len = encoded.length;
    var lat = 0,
      lng = 0;

    while (index < len) {
      var b,
        shift = 0,
        result = 0;

      do {
        b = encoded.charCodeAt(index++) - 63;
        result = result | ((b & 0x1f) << shift);
        shift += 5;
      } while (b >= 0x20);

      var dlat = (result & 1) !== 0 ? ~(result >> 1) : result >> 1;
      lat += dlat;

      shift = 0;
      result = 0;

      do {
        b = encoded.charCodeAt(index++) - 63;
        result = result | ((b & 0x1f) << shift);
        shift += 5;
      } while (b >= 0x20);

      var dlng = (result & 1) !== 0 ? ~(result >> 1) : result >> 1;
      lng += dlng;

      var p = {
        lat: lat / 1e5,
        lng: lng / 1e5,
      };
      poly.push(p);
    }

    return poly;
  }

  getData = () => {
    if (this.timeoutData !== null) {
      clearInterval(this.timeoutData);
      this.timeoutData = null;
    }

    this.setState(
      {
        isLoad: true,
      },
      () => {
        axiosConfig("tracking/get-data", {
          data: {
            network: this.state.network,
            group: this.state.group,
            region: this.state.region,
            agency: this.state.agency,
            user: this.state.user,
            date: this.state.date,
          },
        })
          .then((res) => {
            if (res.data.success) {
              // Les données sont posées dans le state AVANT tout tracé : la
              // carte se charge de façon asynchrone et n'est pas forcément
              // prête ici. Tracer d'abord faisait échouer tout le .then() sur
              // un googleMaps null, et le .catch() avalait l'erreur — la page
              // restait vide sans le moindre message.
              this.setState(
                {
                  data: res.data.data,
                  dataRoads: res.data.dataRoads,
                  dataAgency: res.data.dataAgency,
                  total: res.data.total,
                  // La tournée isolée n'est conservée que si l'expert est
                  // toujours dans le résultat : sinon le rafraîchissement
                  // horaire laisserait une carte vide sans explication.
                  selectedExpert:
                    this.state.selectedExpert !== null &&
                    res.data.dataRoads.hasOwnProperty(this.state.selectedExpert)
                      ? this.state.selectedExpert
                      : null,
                  isEmpty: false,
                  dateSync: moment(),
                  isLoad: false,
                },
                () => {
                  this.drawRoads();

                  this.timeoutData = setInterval(() => {
                    this.getData();
                  }, 60 * 60 * 1000);
                }
              );
            } else {
              // Le serveur répond { success: false, error: "no result" } quand
              // la requête ne ramène aucune ligne — cas courant : un périmètre
              // sans RDV ce jour-là, ou un week-end. Ce n'est pas une panne :
              // on vide la carte et on l'affiche, au lieu de laisser en place
              // les résultats précédents sans un mot.
              this.setState(
                {
                  data: [],
                  dataRoads: {},
                  dataAgency: [],
                  total: null,
                  selectedExpert: null,
                  isEmpty: true,
                  dateSync: moment(),
                  isLoad: false,
                },
                () => this.drawRoads()
              );
            }
          })
          .catch((res) => {
            this.setState({ isLoad: false });
          });
      }
    );
  };

  // Clés des tournées à afficher : une seule quand une ligne de la légende est
  // sélectionnée, toutes sinon.
  getVisibleExpertIds = () => {
    const { dataRoads, selectedExpert } = this.state;

    if (selectedExpert !== null && dataRoads.hasOwnProperty(selectedExpert)) {
      return [selectedExpert];
    }

    return Object.keys(dataRoads);
  };

  // Une ligne de légende par expert, triée par nom.
  getTours = () => {
    const { dataRoads } = this.state;

    return Object.keys(dataRoads)
      .map((key) => ({
        id: key,
        expert: dataRoads[key].expert,
        color: expertColor(dataRoads[key].color),
        stops: dataRoads[key].paths.length,
        expertises: dataRoads[key].expertises || 0,
        distance: dataRoads[key].distance,
        duration: dataRoads[key].duration,
      }))
      .sort((a, b) => `${a.expert}`.localeCompare(`${b.expert}`));
  };

  handleSelectExpert = (id) => {
    this.setState({ selectedExpert: id }, () => this.drawRoads());
  };

  // Trace un itinéraire par expert. Appelée après chaque chargement de données
  // et au montage de la carte, car les deux arrivent dans un ordre imprévisible.
  drawRoads = () => {
    const { googleMaps, dataRoads } = this.state;

    if (!googleMaps || !googleMaps.maps || !googleMaps.map) {
      return;
    }

    this.flightPaths.forEach((flightPath) => flightPath.setMap(null));
    this.flightPaths = [];

    this.getVisibleExpertIds().forEach((key) => {
      const element = dataRoads[key];
      const color = expertColor(element.color);

      element.points.forEach((points) => {
        const flightPath = new googleMaps.maps.Polyline({
          path: this.decodePolyline(points),
          geodesic: false,
          strokeColor: color,
          strokeOpacity: 1,
          strokeWeight: 2,
          // Flèches le long du tracé : elles donnent le sens de la tournée,
          // que les numéros des étapes confirment de proche en proche.
          icons: googleMaps.maps.SymbolPath
            ? [
                {
                  icon: {
                    path: googleMaps.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                    scale: 2,
                    strokeColor: color,
                    fillColor: color,
                    fillOpacity: 1,
                  },
                  offset: "0",
                  repeat: "120px",
                },
              ]
            : undefined,
        });

        flightPath.setMap(googleMaps.map);
        this.flightPaths.push(flightPath);
      });
    });
  };

  handleApiLoaded = (google) => {
    this.setState({ googleMaps: google }, () => this.drawRoads());
  };

  handleOpenModal = (idx) => {
    this.setState({
      isModal: true,
      idxModal: idx,
    });
  };

  render() {
    const { total, selectedExpert } = this.state;
    const visibleExpertIds = this.getVisibleExpertIds();

    return (
      <FadeIn>
        <Nav
          title={`Où est mon expert ? ${
            this.state.dateSync
              ? this.state.dateSync.format("DD/MM/YYYY HH:mm:ss")
              : ""
          }`}
          className="mb-10 mb-20-xl"
        />
        <ShowOptionsNGRA
          initialFilters={filterStore.getState().getPageFilters("tracking")}
          isChange={true}
          isInitialLoad={true}
          className="mb-10 mb-20-xl"
          onDataChange={this.handleDataChange}
          isUser={true}
          isDateEnd={true}
          dateEndName={"Date"}
          visibilityRole={this.props.visibilityRole}
          visibilityType={this.props.visibilityType}
          preloadRole={this.props.preloadRole}
          preloadType={this.props.preloadType}
          limitUserType={this.props.limitUserType}
          limitUserRole={this.props.limitUserRole}
          userType={[1, 2]}
          isDefaultAllUser={true}
        />
        <Card
          title={`Carte — ${total ? total.expertises : 0} expertise${
            total && total.expertises > 1 ? "s" : ""
          }`}
          className="mb-10 mb-20-xl"
        >
          {this.state.isEmpty ? (
            <p className="mb-10 text-center">
              Aucun rendez-vous pour ce périmètre à cette date.
            </p>
          ) : null}
          <FormCheckbox
            className="mb-10"
            name="isAllFolder"
            checked={this.state.isAllFolder}
            onChange={this.handleCheckboxChange}
            text="Afficher toutes les expertises"
          />
          <FormCheckbox
            className="ml-10 mb-10"
            name="isAgency"
            checked={this.state.isAgency}
            onChange={this.handleCheckboxChange}
            text="Afficher les agences"
          />
          <Row>
            <Col xs={12} lg={9}>
              <div style={{ height: "900px" }}>
                <GoogleMapReact
                  bootstrapURLKeys={{
                    key: GOOGLE_MAPS_KEY,
                  }}
                  center={{
                    lat: 46.227638,
                    lng: 2.213749,
                  }}
                  zoom={7}
                  yesIWantToUseGoogleMapApiInternals
                  onGoogleApiLoaded={(google) => this.handleApiLoaded(google)}
                >
                  {visibleExpertIds.map((key) => {
                    // `order` et `references` viennent du serveur ; on retombe
                    // sur l'indice et une liste vide pour rester affichable si
                    // le front est déployé avant le back.
                    return this.state.dataRoads[key].paths.map(
                      (path, pathIdx) => {
                        const order = path.order || pathIdx + 1;

                        return (
                          <TourMarker
                            key={`${key}-${order}`}
                            lat={path.lat}
                            lng={path.lng}
                            color={expertColor(this.state.dataRoads[key].color)}
                            icon={
                              path.locationCode === 1
                                ? faUserAlt
                                : path.locationCode === 3
                                ? faBuilding
                                : faMapMarkerAlt
                            }
                            order={order}
                            title={[
                              [order, path.hour].filter(Boolean).join(". "),
                              this.state.dataRoads[key].expert,
                              path.location,
                              (path.references || []).join(", "),
                            ]
                              .filter(Boolean)
                              .join(" — ")}
                            onOpenModal={() => this.handleOpenModal(path.idx)}
                          />
                        );
                      }
                    );
                  })}
                  {this.state.isAllFolder
                    ? this.state.data.map((element, idx) => {
                        // Une tournée isolée n'affiche que les expertises de cet
                        // expert : sinon la carte reste noyée sous les marqueurs des
                        // autres.
                        if (
                          selectedExpert !== null &&
                          `${element.expertId}` !== `${selectedExpert}`
                        ) {
                          return null;
                        }

                        if (
                          element.garageLatitude &&
                          element.garageLongitude &&
                          element.typeData === "2" &&
                          element.locationCode !== 1 &&
                          element.locationCode !== 3
                        ) {
                          return (
                            <MapMarker
                              key={idx}
                              lat={element.garageLatitude}
                              lng={element.garageLongitude}
                              color={element.expertColor}
                              expertColor={null}
                              icon={faMapMarkerAlt}
                              onOpenModal={() => this.handleOpenModal(idx)}
                            />
                          );
                        } else if (
                          element.clientLatitude &&
                          element.clientLongitude &&
                          element.typeData === "2" &&
                          element.locationCode === 1
                        ) {
                          return (
                            <MapMarker
                              key={idx}
                              lat={element.clientLatitude}
                              lng={element.clientLongitude}
                              color={element.expertColor}
                              expertColor={null}
                              icon={faUserAlt}
                              onOpenModal={() => this.handleOpenModal(idx)}
                            />
                          );
                        } else if (
                          element.agencyLatitude &&
                          element.agencyLongitude &&
                          element.typeData === "2" &&
                          element.locationCode === 3
                        ) {
                          return (
                            <MapMarker
                              key={idx}
                              lat={element.agencyLatitude}
                              lng={element.agencyLongitude}
                              color={element.expertColor}
                              expertColor={null}
                              icon={faBuilding}
                              onOpenModal={() => this.handleOpenModal(idx)}
                            />
                          );
                        } else {
                          return null;
                        }
                      })
                    : null}
                  {this.state.isAgency
                    ? this.state.dataAgency.map((element, idx) => {
                        if (element.lat && element.lng) {
                          return (
                            <MapMarker
                              key={idx}
                              lat={element.lat}
                              lng={element.lng}
                              // color={element.expertColor}
                              // expertColor={null}
                              icon={faBuilding}
                              // id={element.id}
                              onOpenModal={() => {}}
                            />
                          );
                        } else {
                          return null;
                        }
                      })
                    : null}
                </GoogleMapReact>
              </div>
            </Col>
            <Col xs={12} lg={3}>
              <TourLegend
                total={total}
                tours={this.getTours()}
                selected={selectedExpert}
                onSelect={this.handleSelectExpert}
              />
            </Col>
          </Row>
        </Card>
        <Modal
          show={this.state.isModal}
          onClose={() => this.setState({ isModal: false, idxModal: null })}
          title="Expertise"
        >
          {this.state.idxModal !== null ? (
            <>
              <p>
                Date de passage :{" "}
                <b>{this.state.data[this.state.idxModal].date}</b>
              </p>
              <p>
                Référence :{" "}
                <b>{this.state.data[this.state.idxModal].reference}</b>
              </p>
              <p>
                Lieu RDV :{" "}
                <b>{this.state.data[this.state.idxModal].location}</b>
              </p>
              <p>
                Nature expertise :{" "}
                <b>{this.state.data[this.state.idxModal].natureExpertise}</b>
              </p>
              <p>
                Expert : <b>{this.state.data[this.state.idxModal].expert}</b>
              </p>
              {this.state.data[this.state.idxModal].locationCode !== 1 &&
              this.state.data[this.state.idxModal].locationCode !== 3 ? (
                <>
                  <p>
                    Réparateur :{" "}
                    <b>{this.state.data[this.state.idxModal].garageName}</b>
                  </p>
                  <p>
                    Adresse :{" "}
                    <b>
                      {this.state.data[this.state.idxModal].garageAddress1},{" "}
                      {this.state.data[this.state.idxModal].garageAddress2}
                    </b>
                  </p>
                  <p>
                    Code postal / Ville :{" "}
                    <b>
                      {this.state.data[this.state.idxModal].garageZipCode}{" "}
                      {this.state.data[this.state.idxModal].garageCity}
                    </b>
                  </p>
                </>
              ) : null}
              {this.state.data[this.state.idxModal].locationCode === 1 ? (
                <>
                  <p>
                    Adresse :{" "}
                    <b>
                      {this.state.data[this.state.idxModal].clientAddress1},{" "}
                      {this.state.data[this.state.idxModal].clientAddress2}
                    </b>
                  </p>
                  <p>
                    Code postal / Ville :{" "}
                    <b>
                      {this.state.data[this.state.idxModal].clientZipCode}{" "}
                      {this.state.data[this.state.idxModal].clientCity}
                    </b>
                  </p>
                </>
              ) : null}
            </>
          ) : null}
        </Modal>
        <Loader show={this.state.isLoad} />
      </FadeIn>
    );
  }
}
